// ISO 3166-1 alpha-2 codes, for the checkout's country (Stripe Tax takes these). Names come from the browser, in the
// visitor's language.
const CODES = (
    'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC ' +
    'CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD ' +
    'GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH ' +
    'KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW ' +
    'MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC ' +
    'SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY ' +
    'UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'
).split(' ');

// Where a postal code is needed to work out the tax.
export const POSTAL_CODE_COUNTRIES = ['US', 'CA'];

export interface Country {
    code: string;
    name: string;
}

let countries: Country[] | undefined;

export function allCountries(): Country[] {
    if (!countries) {
        let names: Intl.DisplayNames | undefined;
        try {
            names = new Intl.DisplayNames(undefined, { type: 'region' });
        } catch {
            // Very old browsers: the codes alone.
        }
        countries = CODES
            .map(code => ({ code, name: names?.of(code) ?? code }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }
    return countries;
}

// The visitor's country from their browser's language (en-US → US), as a first guess. Undefined when it doesn't say.
export function guessCountry(): string | undefined {
    for (const language of navigator.languages ?? [navigator.language]) {
        try {
            const region = new Intl.Locale(language).maximize().region;
            if (region && CODES.includes(region)) {
                return region;
            }
        } catch {
            // Not a valid language tag.
        }
    }
    return undefined;
}
